import { useEffect, useState } from "react";
import { API_URL } from "@/config";

export function useFounding(pollMs = 20000) {
  const [state, setState] = useState({ taken: null, cap: 1299, total: null });

  useEffect(() => {
    let live = true;
    const load = async () => {
      try {
        const res = await fetch(`${API_URL}/waitlist/founding`);
        if (!res.ok) return;
        const data = await res.json();
        if (live) setState({ taken: data.taken, cap: data.cap, total: data.total });
      } catch {
        /* keep last known value */
      }
    };
    load();
    const id = setInterval(load, pollMs);
    return () => {
      live = false;
      clearInterval(id);
    };
  }, [pollMs]);

  return state;
}
